<template>
  <div class="elasticComputeCloudResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px">
      <div v-if="companyIdShow == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            @on-change="changeCompanyID"
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            placeholder="公司"
            :transfer="true"
          >
            <Option
              v-for="item in companyIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
        <Col span="6">
          <!--按账户筛选  -->
          <Select
            v-model="accountSearchKey"
            filterable
            multiple
            :max-tag-count="1"
            placeholder="请输入账户"
            @on-change="changeAccountId(accountSearchKey)"
            :transfer="true"
          >
            <Checkbox
              v-model="singleAccount"
              @on-change="selectAccountAll"
              style="display: block; text-align: right"
              v-if="accountList.length > 0"
              >{{ $t("alarms.common.allSelected") }}</Checkbox
            >
            <Option
              :value="item.id"
              v-for="item in accountList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
    </Row>
    <Row :gutter="4">
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="instanceId"
          :placeholder="$t('RAM.common.QuerybyInstanceID')"
        />
      </Col>
      <Col span="5">
        <Input
          v-model="instanceName"
          :placeholder="$t('RAM.common.QuerybyInstanceName')"
        />
      </Col>
      <Col span="5">
        <Input
          v-model="publicIp"
          :placeholder="$t('RAM.common.QuerybyPublicIP')"
        />
      </Col>
      <Col span="2">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:ali:elasticComputeCloudResourceAli:page'
          ]"
          @click="search()"
          >{{ $t("alarms.common.search") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableElasticComputeCloudResource from "../ecs/TableElasticComputeCloudResource.vue";
var tableElasticComputeCloudResource = TableElasticComputeCloudResource;
export default {
  name: "ElasticComputeCloudResourceSearch",
  data() {
    return {
      companyIdShow: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountSearchKey: [],
      singleAccount: false,
      accountList: [],
      accountName: "",
      instanceId: "",
      instanceName: "",
      publicIp: ""
    };
  },
  mounted: function() {
    if (this.companyIdShow == 1) {
      this.listRegisterInformation();
    } else {
      // tableElasticComputeCloudResource.methods.showAll();
    }
  },
  methods: {
    //查询公司
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.accountSearchKey = [];
        this.getAliyunAccountByCompanyId();
      });
    },
    /* 账号 */
    getAliyunAccountByCompanyId: function() {
      this.$api.account
        .getAliyunAccountByCompanyId("companyId", this.companyId)
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.accountList.length; i++) {
              this.accountSearchKey.push(this.accountList[i].id);
            }
          }
        });
    },
    // 切换公司
    changeCompanyID: function() {
      this.accountSearchKey = [];
      this.getAliyunAccountByCompanyId();
    },
    // 切换账户
    changeAccountId: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    selectAccountAll() {
      this.accountSearchKey = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountSearchKey.push(item.id);
        });
      } else {
        this.accountSearchKey = [];
      }
    },
    search: function() {
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("publicIp", this.publicIp);
      eventBus.$emit("instanceName", this.instanceName);
      eventBus.$emit("instanceId", this.instanceId);
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountSearchKey", this.accountSearchKey);
      tableElasticComputeCloudResource.methods.showAll();
    }
  }
};
</script>
<style scoped>
.elasticComputeCloudResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/ecs/ElasticComputeCloudResourceSearch.vue